import { render } from "./LogisticTableCoord.vue?vue&type=template&id=e45b70d2"
import script from "./LogisticTableCoord.vue?vue&type=script&lang=js"
export * from "./LogisticTableCoord.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__